import { EndType } from '@wix/ambassador-pricing-plans-v3-plan/types';

/**
 * @returns true if pricing variant is subscription based.
 */
export const isRecurringVariant = variant => {
  var _variant$billingTerms, _variant$billingTerms3;
  if (((_variant$billingTerms = variant.billingTerms) == null ? void 0 : _variant$billingTerms.endType) === EndType.UNTIL_CANCELLED) {
    var _variant$billingTerms2;
    return !!((_variant$billingTerms2 = variant.billingTerms) != null && _variant$billingTerms2.billingCycle);
  }
  if (((_variant$billingTerms3 = variant.billingTerms) == null ? void 0 : _variant$billingTerms3.endType) === EndType.CYCLES_COMPLETED) {
    var _variant$billingTerms4;
    return ((_variant$billingTerms4 = variant.billingTerms) == null || (_variant$billingTerms4 = _variant$billingTerms4.cyclesCompletedDetails) == null ? void 0 : _variant$billingTerms4.billingCycleCount) !== '1';
  }
  return false;
};
//# sourceMappingURL=is-recurring-variant.js.map